import React from 'react'
import ResponsiveModal, {
  ModalSizes,
  ResponsiveModalActions,
  ResponsiveModalBody,
} from '@src/components/ResponsiveModal/ResponsiveModal'
import { Button, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

interface DeleteModalProps {
  dialogOpen: boolean
  handleClose: () => void
  handleDelete: () => void
  deleteType: string
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  dialogOpen,
  handleClose,
  handleDelete,
  deleteType,
}) => {
  const deleteModalMessage =
    deleteType === 'All' ? (
      <FormattedMessage
        id="CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES"
        defaultMessage="Are you sure you want to remove ALL items from your order?"
      />
    ) : (
      <FormattedMessage
        id="CONF_DELETE_ITEM_MSG_DNA_PLATES"
        defaultMessage="Are you sure you want to remove the selected item from your order?"
      />
    )

  const buttonText =
    deleteType === 'All' ? (
      <FormattedMessage
        id="CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES"
        defaultMessage="Delete All"
      />
    ) : (
      <FormattedMessage
        id="CONF_DELETE_BUTTON_TEXT_DNA_PLATES"
        defaultMessage="Delete"
      />
    )
  const modalTitle = (
    <FormattedMessage
      id="CONF_DELETE_ITEM_CONFIRMATION_TEXT"
      defaultMessage="Delete Confirmation"
    />
  )
  return (
    <ResponsiveModal
      open={dialogOpen}
      onClose={handleClose}
      size={ModalSizes.Small}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          {modalTitle}
        </Typography>
      )}
    >
      <ResponsiveModalBody>
        {deleteModalMessage}
        <ResponsiveModalActions>
          <Button
            onClick={handleClose}
            color="primary"
            id="delete-cancel-button"
            data-testid="delete-cancel-button"
            variant="outlined"
          >
            <FormattedMessage id="CANCEL" defaultMessage="Cancel" />
          </Button>
          <Button
            onClick={handleDelete}
            color="primary"
            variant="contained"
            id="delete-confirm-button"
            data-testid="delete-confirm-button"
          >
            {buttonText}
          </Button>
        </ResponsiveModalActions>
      </ResponsiveModalBody>
    </ResponsiveModal>
  )
}

export default DeleteModal
